import React, { useState } from "react"
import { graphql } from "gatsby"

import AppTemplate from "../components/AppTemplate/AppTemplate"
import SEO from "../components/seo"
import CardBlog from "../components/CardBlog/CardBlog"

const tags = [
  // "responsive",
  "motivation",
  "tutorials",
  // "javascript",
  "devchallenges",
  // "react",
  // "vue",
  // "carreer",
  // "full-stack",
  // "front-end",
]

function intersect(a, b) {
  var setA = new Set(a)
  var setB = new Set(b)
  var intersection = new Set([...setA].filter(x => setB.has(x)))
  return Array.from(intersection)
}

const BlogIndex = ({ data }) => {
  const posts = data.allMarkdownRemark.edges

  const [selectedTags, setSelectedTags] = useState([])

  const onTagSelected = tag => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => tag !== t))
    } else {
      setSelectedTags([...selectedTags, tag])
    }
  }

  return (
    <AppTemplate
      onTagSelected={onTagSelected}
      selectedTags={selectedTags}
      tags={tags}
    >
      <SEO title="All posts" />

      <h1
        style={{
          marginTop: 0,
          marginBottom: `var(--space-3xl)`,
          textTransform: "capitalize",
          color: "var(--primary-text-color)",
          fontSize: "var(--text-2xl)",
        }}
      >
        Posts
      </h1>

      {posts
        .filter(({ node }) => {
          if (selectedTags.length <= 0) {
            return true
          }

          return intersect(node.frontmatter.tags, selectedTags).length > 0
        })
        .map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug

          return (
            <CardBlog
              onTagSelected={onTagSelected}
              key={node.fields.slug}
              title={title}
              to={node.fields.slug}
              excerpt={node.excerpt}
              date={node.frontmatter.date}
              thumbnailImage={node.frontmatter.thumbnailImage}
              author={node.frontmatter.author}
              tags={node.frontmatter.tags}
            />
          )
        })}
    </AppTemplate>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            thumbnailImage
            tags
            author {
              bio
              id
              profilePicture
              name
              devchallengesId
            }
          }
        }
      }
    }
  }
`
